import { router } from "@inertiajs/react"
import { MapPin, Users } from "lucide-react"

import VerifiedBadge from "@/components/verified-badge"
import type Tryout from "@/types/serializers/Tryout"
import type { TryoutWithClubTrait } from "@/types/serializers/Tryout"

type TryoutCardProps = {
  tryout: Tryout & TryoutWithClubTrait
}

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString("es-AR", {
    day: "numeric",
    month: "short",
    year: "numeric",
  })
}

export default function TryoutCard({ tryout }: TryoutCardProps) {
  return (
    <div
      className="border-border bg-card hover:border-krown-300 cursor-pointer rounded-lg border p-4 transition-colors"
      onClick={() => router.visit(`/pruebas/${tryout.slug}`)}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="mb-1 flex items-center gap-2">
            <span className="text-krown-100 text-sm font-medium">
              {tryout.club_profile.name}
            </span>
            <VerifiedBadge show={tryout.club_profile.verified} size="sm" />
          </div>
          <h3 className="mb-2 text-base font-semibold text-white">
            {tryout.title}
          </h3>
          <div className="text-muted-foreground mb-3 flex flex-wrap items-center gap-3 text-xs">
            {tryout.free && (
              <span className="bg-krown-accent/20 text-krown-accent rounded-full px-2 py-0.5 font-medium">
                Gratis
              </span>
            )}
            {tryout.city && (
              <span className="flex items-center gap-1">
                <MapPin className="h-3 w-3" />
                {[tryout.city, tryout.region, tryout.country]
                  .filter(Boolean)
                  .join(", ")}
              </span>
            )}
          </div>
          <p className="text-muted-foreground line-clamp-2 text-sm">
            {tryout.description}
          </p>
        </div>
        <div className="flex flex-col items-end gap-2">
          <span className="text-krown-grey-50 text-xs">
            {formatDate(tryout.created_at)}
          </span>
          <span className="text-krown-grey-50 flex items-center gap-1 text-xs">
            <Users className="h-3 w-3" />
            {tryout.applications_count}
          </span>
        </div>
      </div>
    </div>
  )
}
